import React from "react";
import "./Content.scss";

const Content = ({className}) => {
  return <div className={"Content " + className}>Content</div>;
};

export default Content;
